import { createRoot } from 'react-dom/client';

import { SchoolLevelGivingLanding } from './SchoolLevelGivingLanding';

$(function () {
    const root = createRoot(document.getElementById('content')!);
    root.render(
        <SchoolLevelGivingLanding />,
    );
});
